import { PurchaseOfferSortingInput, PurchaseOfferStatusEnum } from '../../../../shared/graphql-types';

export class OffersLookupCriteria {
  status = [PurchaseOfferStatusEnum.Active, PurchaseOfferStatusEnum.Bid, PurchaseOfferStatusEnum.BidApproved];
  sorting: PurchaseOfferSortingInput = {legs: {departureTimeUTC: true}};
  airportCode: string  = null;
  skip = 0;
  limit = 20;
  total = 0;
}
